import { render, staticRenderFns } from "./accountRetainPirate.vue?vue&type=template&id=c58d038e&scoped=true&"
import script from "./accountRetainPirate.vue?vue&type=script&lang=js&"
export * from "./accountRetainPirate.vue?vue&type=script&lang=js&"
import style0 from "./accountRetainPirate.vue?vue&type=style&index=0&id=c58d038e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58d038e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c58d038e')) {
      api.createRecord('c58d038e', component.options)
    } else {
      api.reload('c58d038e', component.options)
    }
    module.hot.accept("./accountRetainPirate.vue?vue&type=template&id=c58d038e&scoped=true&", function () {
      api.rerender('c58d038e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/accountRetainPirate.vue"
export default component.exports